<template>
  <div style="width: 100%">
    <p style="font-weight: bold; margin-bottom: 5px;">
      <span :class="'highchart-legend-dot ' + colorClass"></span>
      <slot>
        Title
      </slot>
    </p>
    <p>Aus {{capital | currencyRounded }} wurden in {{timeText}}:</p>
    <v-row no-gutters>
      <v-col>
        <span :class="colorClass + '--text'" class="amount">{{result| currencyRounded }}</span>
      </v-col>
      <v-col>
        <span class="fin-color-accent-gray--text">Jährliche Rendite:</span>
        <fin-percentage-change :absolute-format="$options.filters.currencyChange" :absoluteChangeText=null
                               :change="yield_pa_amount" :text-color="$finColors.accentGray2"
                               absolute percent-only/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FinPercentageChange from "@/components/common/PercentageChange/index"

export default {
  name: 'finDemoResult',
    components: {FinPercentageChange},
    props: {
      capital: {
        type: Number
      },
      yield_pa_amount: {
        type: Number
      },
      timeText: {
          type: String
      },
      result: {
          type: Number
      },
      colorClass: {
        type: String
      },
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

  .highchart-legend-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-right: 10px;
    display: inline-block;
  }

  .amount {
    font-size: 40px;
    font-weight: bold;
    line-height: 1;

    @media only screen and (max-width: 960px) {
      font-size: 32px;
    }
  }
</style>
